import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import SignIn from './SignIn';
import { styles } from '../../styles/auth-styles';
import titleImg from '../../images/msd-dashboard-logo.png';

function AuthPage(props) {
  const { classes } = props;
  return (
    <div>
      <img className={classes.titleImg} src={titleImg} />
      <SignIn className={classes.signIn} childProps={props.childProps}/>
    </div>
  );
}

AuthPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthPage);



// WEBPACK FOOTER //
// ./src/components/auth/AuthPage.js